export interface ErrorResponse {
    status: number;
    detail: string | null;
}

const ErrorOrigin = {
    DRIVER_ADMINISTRATION: 0,
    TAG_SERVICE: 1,
    USER_ADMINISTRATION: 2,
} as const;

type ErrorOrigin = (typeof ErrorOrigin)[keyof typeof ErrorOrigin];

export { ErrorOrigin };

export const getErrorCode = (errorResponse: ErrorResponse, errorOrigin: ErrorOrigin) => {
    if (errorResponse.status === 403 || errorResponse.status === 401) {
        return 'UNAUTHORIZED';
    }
    const errorCodeRegex = /^\[(.+)]:.*$/;
    const matches = errorResponse.detail && errorCodeRegex.exec(errorResponse.detail);
    const errorCode = matches && matches.length === 2 ? matches[1] : null;

    if (errorCode === null) {
        switch (errorOrigin) {
            case ErrorOrigin.DRIVER_ADMINISTRATION:
                return 'FXX';
            case ErrorOrigin.TAG_SERVICE:
                return 'TXX';
            case ErrorOrigin.USER_ADMINISTRATION:
                return 'UXX';
        }
    }

    return errorCode;
};
